import { gql } from 'apollo-boost';

export const ir = gql`
  query ($id: ID, $allocation: Int) {
    ir(filters: {id: $id, allocation: $allocation}) {
      edges {
        node {
          cashAmount
          goodsAmount
          servicesAmount
          volunteerismAmount
          accountName
          granteeFullName
          donorFullName
          logo
          report
          allocation
          portfolioAccountName
          invested
          tasks
          legacy
        }
      }
    }
  }
`;
